import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { usePlansContext, useTiersInfo } from '@mc/plans-ui'
import { useMCProExperiment } from '../../hooks/useMCProExperiment'
import { MC_PRO_TIER_I18N_NAMESPACE, i18nInstance } from '../../i18n'
import { BADGES, Tile } from './Tile'

const KEY_STEPS: Record<string, (index: number, total: number) => number> = {
  ArrowDown: (index, total) => (index + 1) % total,
  ArrowRight: (index, total) => (index + 1) % total,
  ArrowUp: (index, total) => (index - 1 + total) % total,
  ArrowLeft: (index, total) => (index - 1 + total) % total,
  Home: () => 0,
  End: (_, total) => total - 1,
}

const onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
  const step = KEY_STEPS[event.key]
  const group = event.currentTarget.closest('[role="radiogroup"]')
  if (!step || !group) return

  const radios = Array.from(
    group.querySelectorAll<HTMLButtonElement>('[role="radio"]'),
  )
  const index = radios.indexOf(event.currentTarget)

  event.preventDefault()
  const next = radios[step(index, radios.length)]
  next.focus()
  next.click()
}

export const StackedTiles = withI18nContext(i18nInstance)(() => {
  const { t } = useTranslation(MC_PRO_TIER_I18N_NAMESPACE)
  const { selectedPlan } = usePlansContext()
  const { variant2Layout } = useMCProExperiment()
  const { individual, duo, family, familyPlus } = useTiersInfo()
  const tiers = [individual, duo, family, familyPlus].filter(
    (tier) => tier.productId,
  )
  const selectedIndex = tiers.findIndex(
    (tier) => tier.productId === selectedPlan?.productId,
  )
  const focusableIndex = Math.max(selectedIndex, 0)

  return (
    <div
      role='radiogroup'
      aria-label={t('stackedTiles.label')}
      className='container d-flex flex-column mc-gap-4 mc-mt-8'
    >
      {tiers.map((tier, index) => (
        <Tile
          tier={tier}
          key={tier.productId}
          badge={BADGES[variant2Layout][tier.hierarchy]}
          tabIndex={index === focusableIndex ? 0 : -1}
          onKeyDown={onKeyDown}
        />
      ))}
    </div>
  )
})
